import { send } from 'server';
import { IServerSendResponse, TServerSendRequest } from 'js/hooks/socket/types';

import * as Types from '../../types';

export const changePassword = ({
    newPassword,
    oldPassword
}: Types.IChangePasswordRequestData): Promise<IServerSendResponse<void>> => send({
    ID: 31028,
    responses: [31029, 31030],
    description: 'Change password',
    newPassword,
    oldPassword
} as TServerSendRequest<Types.IChangePasswordRequestData>);
